import { Editor, Node, Path, Transforms } from 'slate';
import { CoverageRule, getHeadingLevel, isReferenceTable } from '../types';

export const setCoverage = (editor: Editor, path: Path, rule: CoverageRule): void => {
  const [node] = Editor.node(editor, path);
  if (!isMarkableTarget(node, rule)) return;
  Transforms.setNodes(editor, { coverage: { rule } } as Partial<Node>, { at: path });
};

const isMarkableTarget = (node: Node, rule: CoverageRule): boolean => {
  if (rule.kind === 'all-cells') return isReferenceTable(node);
  return getHeadingLevel(node) !== null;
};
